import { useEffect } from 'react';
import { Router, Switch, Redirect } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { useDispatch } from 'react-redux';

import CustomerOrganizationFormPage from '../CustomerOrganizationForm/CustomerOrganizationForm';
import FrontPage from '../FrontPage/FrontPage';

import { HIDDEN_PAGE_PATHS } from '../../utils';
import CustomRoute from './CustomRoute';
import BasicLayout from './Layouts/BasicLayout';
import WithNavigationLayout from './Layouts/WithNavigationLayout';
import UserList from '../Users/UserList/UserList';
import UserProfile from '../Users/UserProfile/UserProfile';
import Order from '../Order/Order';
import { orderBaseUrl } from '../Order/OrderStepper/OrderStepper';
import UserGroups from '../UserGroups/UserGroups';
import UserGroupDetails from '../UserGroups/UserGroupDetails/UserGroupDetails';
import DetailsPageLayout from './Layouts/DetailsPageLayout';
import DetailsPageForOrganizationLayout from './Layouts/DetailsPageForOrganizationLayout';
import CustomerOrders from '../CustomerOrders/CustomerOrders';
import CustomerAssets from '../CustomerAssets/CustomerAssets';
import { AssetDetails } from '../CustomerAssets/AssetDetails';
import { assetFeatureFlagsClient } from '../../api-client/asset-admin-client';
import { AppDispatch } from '../../store';
import { setFeatureFlags } from '../../store/featureFlags';
import AvailabilityPage from './BackOfficePages/Availability/AvailabilityPage';
import DevicesPage from './BackOfficePages/Devices/DevicesPage';
import OrdersPage from './BackOfficePages/Orders/OrdersPage';
import ReportsPage from './BackOfficePages/Reports/ReportsPage';
import ReturnPackageOrdersPage from './BackOfficePages/ReturnPackageOrders/ReturnPackageOrdersPage';
import './App.scss';
import { existingCustomerOrgFormPath, withCustomerOrgFormPath, routes } from './routes';

export const history = createBrowserHistory();

function App() {
  const dispatch: AppDispatch = useDispatch();

  const getFeatureFlags = async () => {
    const featureFlags = (await assetFeatureFlagsClient.featureFlags()).data;
    dispatch(setFeatureFlags(featureFlags));
  };

  useEffect(() => {
    getFeatureFlags();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Router history={history}>
      <Switch>
        <CustomRoute path="/" component={FrontPage} exact layout={BasicLayout} />
        <CustomRoute path={HIDDEN_PAGE_PATHS.orders} component={OrdersPage} exact layout={BasicLayout} />
        <CustomRoute path={HIDDEN_PAGE_PATHS.returnPackageOrders} component={ReturnPackageOrdersPage} exact layout={BasicLayout} />
        <CustomRoute path={HIDDEN_PAGE_PATHS.devices} component={DevicesPage} exact layout={BasicLayout} />
        <CustomRoute path={HIDDEN_PAGE_PATHS.availability} component={AvailabilityPage} exact layout={BasicLayout} />
        <CustomRoute path={HIDDEN_PAGE_PATHS.reports} component={ReportsPage} exact layout={BasicLayout} />
        <Redirect exact from={existingCustomerOrgFormPath} to={withCustomerOrgFormPath(routes.companyInformation)} />
        <CustomRoute
          path={withCustomerOrgFormPath(routes.companyInformation)}
          component={CustomerOrganizationFormPage}
          exact
          layout={WithNavigationLayout}
        />
        <CustomRoute path={withCustomerOrgFormPath(routes.users)} component={UserList} exact layout={WithNavigationLayout} />
        <CustomRoute
          path={`${withCustomerOrgFormPath(routes.userGroups)}/:usergroupid/users/:userid`}
          component={UserProfile}
          exact
          layout={DetailsPageForOrganizationLayout}
        />

        <CustomRoute path={withCustomerOrgFormPath(routes.userGroups)} component={UserGroups} exact layout={WithNavigationLayout} />
        <CustomRoute
          path={`${withCustomerOrgFormPath(routes.userGroups)}/:usergroupid`}
          component={UserGroupDetails}
          layout={DetailsPageForOrganizationLayout}
          exact
        />
        <CustomRoute path={withCustomerOrgFormPath(routes.orders)} component={CustomerOrders} layout={WithNavigationLayout} exact />
        <CustomRoute path={withCustomerOrgFormPath(routes.devices)} component={CustomerAssets} layout={WithNavigationLayout} exact />
        <CustomRoute path={orderBaseUrl} component={Order} layout={BasicLayout} />
        <CustomRoute
          path={`${withCustomerOrgFormPath(routes.devices)}/:assetid`}
          component={AssetDetails}
          exact
          layout={DetailsPageForOrganizationLayout}
        />
        <CustomRoute path={routes.customer} component={CustomerOrganizationFormPage} exact layout={DetailsPageLayout} />
      </Switch>
    </Router>
  );
}

export default App;
